import { useNavigate, useLocation } from "react-router";
import { ISitemapRoutingContext } from "@iventis/sitemaps/src/context/sitemap-routing-context";
import { AssetsSubmenuItemType } from "../components/assets-app";

const baseUrl = `/resources/${AssetsSubmenuItemType.SITEMAPS}`;

export function useSitemapRepositoryRouting(): ISitemapRoutingContext {
    const navigate = useNavigate();
    const location = useLocation();

    const setSelectedSitemapId = (sitemapId: string | null) => {
        // If null is passed as the sitemapId we are going back
        if (sitemapId == null) {
            navigate(`${baseUrl}${location.search}`);
        } else {
            navigate(`${baseUrl}/${sitemapId}${location.search}`);
        }
    };

    const setSelectedSitemapVersionId = (sitemapVersionId: string | null) => {
        // If null is passed as the sitemapVersionId we are going back
        if (sitemapVersionId == null) {
            navigate(`${baseUrl}/${getSelectedSitemapId()}/${location.search}`);
        } else {
            navigate(`${baseUrl}/${getSelectedSitemapId()}/${sitemapVersionId}${location.search}`);
        }
    };

    const setSelectedSitemapVersionLevelId = (sitemapVersionLevelId: string | null) => {
        // If null is passed as the sitemapVersionLevelId we are going back
        if (sitemapVersionLevelId == null) {
            navigate(`${baseUrl}/${getSelectedSitemapId()}/${getSelectedSitemapVersionId()}/${location.search}`);
        } else {
            navigate(`${baseUrl}/${getSelectedSitemapId()}/${getSelectedSitemapVersionId()}/${sitemapVersionLevelId}${location.search}`);
        }
    };

    // Can't use useParams to get route params as the function definitions are higher in the react-tree than where the route is defined, therefore just get the route params manually
    const getSelectedSitemapId = () => {
        const url = location.pathname.split("/");
        return url[url.findIndex((spiltUrl) => spiltUrl === AssetsSubmenuItemType.SITEMAPS) + 1];
    };

    const getSelectedSitemapVersionId = () => {
        const url = location.pathname.split("/");
        return url[url.findIndex((spiltUrl) => spiltUrl === AssetsSubmenuItemType.SITEMAPS) + 2];
    };

    const getSelectedSitemapVersionLevelId = () => {
        const url = location.pathname.split("/");
        return url[url.findIndex((spiltUrl) => spiltUrl === AssetsSubmenuItemType.SITEMAPS) + 3];
    };

    return {
        setSelectedSitemapId,
        setSelectedSitemapVersionId,
        setSelectedSitemapVersionLevelId,
        getSelectedSitemapId,
        getSelectedSitemapVersionId,
        getSelectedSitemapVersionLevelId,
    };
}
